<template>
  <div header="事故基本信息">
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      inline
      :disabled="isDisabled.value"
      label-position="top"
      size="small"
      class="form-input-width"
    >
      <el-form-item
        label="事故时间"
        prop="accidentTime"
      >
        <el-date-picker
          v-model="model.accidentTime"
          placeholder="请选择事故时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          :picker-options="{ disabledDate: now => now > Date.now() }"
          @focus="showPick"
        />
      </el-form-item>
      <el-form-item
        label="事故地点"
        prop="accidentAddress"
      >
        <el-input
          v-model="model.accidentAddress"
          placeholder="请填写事故地点"
        />
      </el-form-item>
      <el-form-item
        label="报案电话"
        prop="reportPhone"
      >
        <el-input
          v-model="model.reportPhone"
          placeholder="请填写报案电话"
        />
      </el-form-item>
      <el-form-item
        label="事故形态"
        prop="accidentSituation"
      >
        <dict-select
          v-model="model.accidentSituation"
          type="accident_situation"
        />
      </el-form-item>
      <el-form-item
        label="天气情况"
        prop="weather"
      >
        <dict-select
          v-model="model.weather"
          type="weather"
        />
      </el-form-item>
      <el-form-item
        label="碰撞类型"
        prop="crashType"
      >
        <dict-select
          v-model="model.crashType"
          type="collision_type"
        />
      </el-form-item>
      <el-form-item
        label="案件处理方式"
        :prop="checkListData.length&&checkListData.includes('1')?'caseDealType':'caseDealType2'"
      >
        <dict-select
          v-model="model.caseDealType"
          type="case_deal_type"
        />
      </el-form-item>
      <el-form-item
        label="交警大队"
        prop="policeGroupId"
      >
        <dict-select
          v-model="model.policeGroupId"
          type="traffic_police"
        />
      </el-form-item>
      <el-form-item
        label="交警信息"
        prop="policeGroupId"
      >
        <pliceCascader :accident="model"/>
      </el-form-item>
      <!-- <el-form-item
        label="行政单位"
        prop="county"
      >
        <dict-select
          v-model="model.county"
          type="addr_county"
        />
      </el-form-item> -->
      <el-form-item
        prop="isOverpass"
        label="是否高架"
      >
        <el-radio-group v-model="model.isOverpass">
          <el-radio :label="false">
            否
          </el-radio>
          <el-radio :label="true">
            是
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        prop="objectDestroyed"
        label="是否物损"
      >
        <el-radio-group v-model="model.objectDestroyed">
          <el-radio :label="false">
            否
          </el-radio>
          <el-radio :label="true">
            是
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="model.objectDestroyed"
        prop="objectName"
        label="物损名称"
      >
        <el-input
          v-model="model.objectName"
          placeholder="请填写物损名称"
        />
      </el-form-item>
      <div class="directPayments">
        <!-- <span class="labelSt">是否接受车损理赔直接赔付给双方车主</span> -->
        <el-form-item prop="directPayments" label="是否接受车损理赔直接赔付给双方车主">
          <el-radio-group v-model="model.directIndemnity">
            <el-radio :label="false">
              否
            </el-radio>
            <el-radio :label="true">
              是
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="accidentDetail" style="margin-top: 10px; width: 100%;font-size: 12px">
        <div
          v-if="model.liabilityStatement"
          prop="objectName"
          label="责任认定书"
        ><span style="color: #17ECFE !important">责任认定信息</span>
          <div style="color: #B1E3FF;margin-top: 20px; font-size: 13px;line-height: 1.5rem">{{model.liabilityStatement}}</div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { validPhone } from '@/utils/validate';
import DictSelect from '@/views/accident/components/dict-select';
import pliceCascader from './pliceCascader'
export default {
  components: { DictSelect, pliceCascader },
  inject: { isDisabled: { default: () => ({ value: false }) }, checkList: { default: ()=> [] } },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      directPayments:'', // 直接赔付
      rules: {
        accidentTime: [{ required: true, message: '请选择事故时间' }],
        reportPhone: [
          { required: true, message: '请输入报案电话' },
          {
            validator(rule, value, cb) {
              if (value && !validPhone(value)) {
                cb(new Error('请输入正确的手机号'));
              } else {
                cb();
              }
            }
          }
        ],
        accidentAddress: [{ required: true, message: '请填写事故地点' }],
        weather: [{ required: true, message: '请选择天气情况' }],
        caseDealType: [{ required: true, message: '请选择案件处理方式' }],
        // county: [{ required: true, message: '请选择行政单位' }]
      },
    };
  },
  computed:{
    checkListData() {
      return this.checkList();
    }
  },
  created() {
    console.log("xxxxx", this.model)
  },
  watch:{
    'model.accidentTime': {
      handler(val) {
        if (!val && this.$route.name === 'AccidentAdd') {
          this.$set(this.model,'accidentTime',this.getNowFormatDate());
        }
      },
      immediate:true
    },
    'model.policeName': {
      handler(val) {
        if (val && this.model.policePhone && this.model.policeGroup) {
          let info = [];
          info[0] = this.model.policeGroup
          info[1] = val + '-' + this.model.policePhone
          this.dictVal = [...info]
          console.log(this.dictVal);
        }
      },
      immediate:true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    showPick() {
      this.$nextTick(()=>{
        // 阻止时间选择器滚动时的冒泡事件
        let pick = document.getElementsByClassName('el-date-picker')[0];
        pick.addEventListener('mousewheel',(e)=>{
          e.stopPropagation();
        });
      });
    },
    showCascader() {
      this.$nextTick(()=>{
        // 阻止级联选择器滚动时的冒泡事件
        let pick = document.getElementsByClassName('el-cascader-panel')[0];
        pick.addEventListener('mousewheel',(e)=>{
          e.stopPropagation();
        });
      });
    },
    getNowFormatDate () {
      let date = new Date();
      let seperator1 = '-'; //年月日之间的分隔
      let seperator2 = ':'; //时分秒之间的分隔
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1; //获取月,如果小于10,前面补个0
      let strDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(); //获取日,如果小于10,前面补个0
      let strHours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(); //获取小时,如果小于10,前面补个0
      let strMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(); //获取分,如果小于10,前面补个0
      let strSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds(); //获取秒,如果小于10,前面补个0
      let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + strHours + seperator2 + strMinutes + seperator2 + strSeconds; //拼接一下
      return currentdate; //返回
    },
    handleChange(value) {
      if (value && value.length) {
        this.model.policePhone = value[1].split('-')[1];
        this.model.policeName = value[1].split('-')[0];
        this.model.policeGroup = value[0];
      }else {
        this.model.policePhone = ''
        this.model.policeName = ''
        this.model.policeGroup = ''
      }

    }
  }
};
</script>
<style lang="scss" scoped>
  ::v-deep.directPayments {
    .labelSt {
      vertical-align: -webkit-baseline-middle;
    }
  }
</style>
